export var getChubbContractRateSwitchTypeMap = function getChubbContractRateSwitchTypeMap() {
  return {
    rate: {
      value: 'rate',
      label: 'By rate'
    },
    total: {
      value: 'total',
      label: 'Total value'
    }
  };
};
export var getChubbContractRateSwitchTypeList = function getChubbContractRateSwitchTypeList() {
  return Object.values(getChubbContractRateSwitchTypeMap());
};